import { render, staticRenderFns } from "./activitylogs.component.vue?vue&type=template&id=862396c8&"
import script from "./activitylogs.component.vue?vue&type=script&lang=tsx&"
export * from "./activitylogs.component.vue?vue&type=script&lang=tsx&"
import style0 from "./activitylogs.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports